/** `countries_dial_codes` ids for the two NANP countries sharing the bare "+1". */
export const US_COUNTRY_ID = 235;
const CANADA_COUNTRY_ID = 39;

const AREA_CODE_LENGTH = 3;

/**
 * Canada's geographic area codes (CNAC's list). Every other bare "+1" number
 * is treated as US: the Caribbean and Pacific NANP members have their own
 * four-digit dial codes in `countries_dial_codes` and match those first.
 */
const CANADIAN_AREA_CODES: ReadonlySet<string> = new Set([
  "204",
  "226",
  "236",
  "249",
  "250",
  "257",
  "263",
  "289",
  "306",
  "343",
  "354",
  "365",
  "367",
  "368",
  "382",
  "387",
  "403",
  "416",
  "418",
  "428",
  "431",
  "437",
  "438",
  "450",
  "460",
  "468",
  "474",
  "506",
  "514",
  "519",
  "548",
  "579",
  "581",
  "584",
  "587",
  "604",
  "613",
  "639",
  "647",
  "672",
  "683",
  "705",
  "709",
  "742",
  "753",
  "778",
  "780",
  "782",
  "807",
  "819",
  "825",
  "867",
  "873",
  "879",
  "902",
  "905",
  "942",
]);

/**
 * Picks the country for a number under the shared "+1" dial code from its area
 * code, since the dial code alone can't tell the US from Canada. Kept free of
 * `libphonenumber-js` so it stays safe for client bundles.
 *
 * @param nationalDigits - The digits after "+1" (area code first).
 * @returns The Canada id for a Canadian area code, otherwise the US id.
 */
export function nanpCountryDialCodeId(nationalDigits: string): number {
  const areaCode = nationalDigits.slice(0, AREA_CODE_LENGTH);
  return CANADIAN_AREA_CODES.has(areaCode) ? CANADA_COUNTRY_ID : US_COUNTRY_ID;
}
